// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip--cpTZd","TooltipContent":"TooltipContent--RSwiZ","TooltipItems":"TooltipItems--x_iRD"};